import { select, takeLeading } from 'redux-saga/effects';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { callApi } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import {
  REQUEST_SEARCH_CLAIM_INFO,
  REQUEST_MAKE_DECISION_CLAIM,
} from 'containers/OpeningClaimPageManager/constants';
import { setSearchClaims } from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { setSearchClaimInfo } from 'containers/OpeningClaimPageManager/actions';

function buildRequestBody(token: string, body: object) {
  return {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  };
}
export function* requestSearchClaimInfo(action: {
  payload: string;
  type: string;
  failedCallBack: Function;
}): Generator {
  const token = get(userToken.get(), 'token');
  if (!token) return;

  const path = `/corporeal/common/search-claim`;

  // 1. First call with claim number
  const firstBody = {
    claimNumber: action.payload,
    lossDate: null,
    withDocuments: 'Y',
  };

  const errorResponse = yield callApi(
    path,
    {},
    buildRequestBody(token, firstBody),
    [],
    setSearchClaims,
  );

  // 2. If we have claims, call again with policyNumber/lossDate
  const searchedClaim = yield select(makeSelectSearchClaims());
  const claims = get(searchedClaim, 'sagis.claims', []);

  if (!isEmpty(claims)) {
    const firstClaim = claims[0];
    const secondBody = {
      policyNumber: firstClaim.policyNumber,
      lossDate: moment(firstClaim.lossDate).format('YYYY-MM-DD'),
      withoutCanceledClaims: 'Y',
    };

    yield callApi(
      path,
      {},
      buildRequestBody(token, secondBody),
      [],
      setSearchClaimInfo,
    );
  }

  // 3. Handle error
  if (errorResponse) {
    yield action.failedCallBack();
  }
}
export function* requestSearchClaimInfoSaga() {
  yield takeLeading(REQUEST_SEARCH_CLAIM_INFO, requestSearchClaimInfo);
}
export function* requestMakeDecisionClaim(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const path = `/corporeal/make-decision-claim-material`;

  const token = get(userToken.get(), 'token');

  if (!token) return;
  const options = {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestMakeDecisionClaimSaga() {
  yield takeLeading(REQUEST_MAKE_DECISION_CLAIM, requestMakeDecisionClaim);
}
export default [requestSearchClaimInfoSaga, requestMakeDecisionClaimSaga];
